import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { FlagTransparentIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { ReportAbuseLink } from '#src/app/shared/components/abuse';

export const ReportAbuseContainer: React.FC = () => {
	const {
		data: {
			petition: { id, slug },
			userSelectableCountries,
		},
	} = usePetitionDetailsPageData();

	return (
		<div className="pt-9" data-qa="report-abuse-section">
			<ReportAbuseLink type="petition" petitionId={id} petitionSlug={slug} countries={userSelectableCountries} v2>
				<button type="button" className="flex items-center gap-1">
					<FlagTransparentIcon size={14} className="text-icon-strong" />
					<Text className="text-typography-strong underline" size="small">
						<Translate value="fe.components.petition_report_abuse.report_link" />
					</Text>
				</button>
			</ReportAbuseLink>
		</div>
	);
};
